import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalGetHiddenAlertsDocument = gql`
  query SalesPortalGetHiddenAlerts($businessOrganizationUUID: uuid!) {
    getAllHubAlerts(
      business_organization_id: $businessOrganizationUUID
      filters: { alert_statuses: HIDDEN }
    ) {
      card_data_json
    }
  }
`;
export function useSalesPortalGetHiddenAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalGetHiddenAlertsQuery,
    Types.SalesPortalGetHiddenAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalGetHiddenAlertsQuery,
    Types.SalesPortalGetHiddenAlertsQueryVariables
  >(SalesPortalGetHiddenAlertsDocument, options);
}
export function useSalesPortalGetHiddenAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalGetHiddenAlertsQuery,
    Types.SalesPortalGetHiddenAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalGetHiddenAlertsQuery,
    Types.SalesPortalGetHiddenAlertsQueryVariables
  >(SalesPortalGetHiddenAlertsDocument, options);
}
export type SalesPortalGetHiddenAlertsQueryHookResult = ReturnType<
  typeof useSalesPortalGetHiddenAlertsQuery
>;
export type SalesPortalGetHiddenAlertsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalGetHiddenAlertsLazyQuery
>;
export type SalesPortalGetHiddenAlertsQueryResult = Apollo.QueryResult<
  Types.SalesPortalGetHiddenAlertsQuery,
  Types.SalesPortalGetHiddenAlertsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalGetHiddenAlertsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalGetHiddenAlertsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalGetHiddenAlertsQuery,
    Types.SalesPortalGetHiddenAlertsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalGetHiddenAlertsQuery,
    Types.SalesPortalGetHiddenAlertsQueryVariables
  >(SalesPortalGetHiddenAlertsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalGetHiddenAlertsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalGetHiddenAlertsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalGetHiddenAlertsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalGetHiddenAlertsQuery,
    Types.SalesPortalGetHiddenAlertsQueryVariables
  >(SalesPortalGetHiddenAlertsDocument, lazyOptions);
}
